module.exports = __webpack_public_path__ + "img/fla.0bd34dea.svg";